import React from 'react';

const EventContainerWrapper = ({ hourStart, hourEnd, timeslotHeight = 102 }) => ({ children }) => {
	const hoursCount = hourEnd - hourStart;
	const gridRows = hoursCount * 60;
	return (
		<div
			className='rbc-events-container'
			style={{ gridTemplateRows: `repeat(${gridRows}, calc(${timeslotHeight}px / 60))` }}
		>
			{children.props.children}
		</div>
	);
};

export default EventContainerWrapper;
